import {makeStyles} from '@material-ui/core/styles';
/**
 * Un hook de estilos general para Capacitaciones e InfoContainer
 */
export const useCapacitacionesStyles = makeStyles(theme => ({
   lista: {
      display: 'flex',
      [theme.breakpoints.down('md')]: {
         height: 'auto'
      },
      [theme.breakpoints.up('md')]: {
         height: '660px'
      }
   },
   TituloPrincipal: {
      paddingBottom: '0.1rem',
      borderBottom: '2px solid #ff5722',
      textAlign: 'center',
      marginTop: '0.5rem'
   },
   IMG: {
      display: 'block',
      width: '100%',
      margin: 'auto 0'
   },
   fadeIn: {
      transition: 'filter 1s ease-in',
      filter: 'blur(7px);'
   },
   fadeOut: {
      transition: 'filter 1s ease-out',
      filter: 'none'
   },
   contenedorInfo: {height: '190px', overflow: 'auto', padding: '10px 50px 0 50px'}
}));
